<template>
  <slot></slot>
</template>

<script lang="ts" setup>
import { inject, onBeforeUnmount, provide, reactive, watch } from 'vue';

const props = withDefaults(defineProps<{
  currentItem: any;
  index: number;
  currentItemKey: string;
  indexKey: string;
  listNode: any;
}>(), {
  currentItem: null,
  currentItemKey: 'currentItem',
  indexKey: 'i',
});

const parentsExtraDataForChildren = inject<any>('parentsExtraDataForChildren', undefined);

const listItemProps = reactive({
  ...parentsExtraDataForChildren,
  [props.currentItemKey]: props.currentItem,
  [props.indexKey]: props.index,
});

if (props.index === 0) {
  props.listNode.extraDataForChildrenForCodeMirror = listItemProps;
  onBeforeUnmount(() => {
    delete props.listNode.extraDataForChildrenForCodeMirror;
  });
}

watch(() => parentsExtraDataForChildren, (val) => {
  Object.keys(val).forEach((key) => {
    if (key !== props.currentItemKey && key !== props.indexKey) {
      listItemProps[key] = val[key];
    }
  });
});

watch(() => [props.currentItemKey, props.indexKey], (val, oldVal) => {
  if (val[0] !== oldVal[0]) {
    delete listItemProps[oldVal[0]];
    listItemProps[val[0]] = props.currentItem;
  }
  if (val[1] !== oldVal[1]) {
    delete listItemProps[oldVal[1]];
    listItemProps[val[1]] = props.index;
  }
});

watch(() => props.currentItem, (val) => {
  listItemProps[props.currentItemKey] = val;
});

provide('parentsExtraDataForChildren', listItemProps)

</script>